import { SelectedMenu } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';
import deleteProduct from 'rangeConfig/shared/behaviors/deleteProduct';
import {
  matchDepth,
  matchHeight,
  matchWidth
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.productListAccessoriesTitle',
  behaviors: {
    productDeleted: [deleteProduct]
  },
  content: [
    {
      id: 'accessories-selected-menu-accessories',
      title: '',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText communicatedSizeText',
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: []
      },
      productTypes: [
        ProductType.SMASTAD_BOX,
        ProductType.SMASTAD_HANGING_STORAGE_CASE,
        ProductType.SMASTAD_HOOK_CLIP,
        ProductType.SMASTAD_MIRROR,
        ProductType.SMASTAD_LABEL_HOLDER
      ],
      productFilters: [matchWidth, matchDepth, matchHeight]
    }
  ]
};

export default selectedMenu;
